<template>
  <div class="wrapper-body">
    <v-card class="flex-container mb-3" style="border-radius: 12px;">
      <v-toolbar class="shadow-none" style="flex: unset;" content-class="h-auto">
        <div class="custom-icon-wrapper">
          <v-icon @click="backToAdminPage()">custom-icon left-arrow-icon</v-icon>
        </div>
        <v-toolbar-title class="size-16 dark-text mx-5">{{ $t("res_Label_OrganizationManagement")
        }}</v-toolbar-title><!-- mx-5 -->
      </v-toolbar>

      <div class="border-top organization-management-dialog d-flex h-100">
        <div style="height: calc(85vh); max-height: calc(85vh)"
          class="tree-section col-md-4 col-lg-4 d-flex flex-column bg-white">
          <!--<div class="tree-wrapper h-100 overflow-auto d-flex flex-column bg-white">-->
          <div class="d-flex gap-2">
            <div class="flex-1">
              <div class="search-bar-gray">
                <v-btn @click="handleSearch()"><v-icon>mdi-magnify</v-icon></v-btn>
                <v-text-field v-model="searchVal" solo :label="$t('res_Label_SearchPlaceHolder')"
                  @keydown.enter="handleSearch()"></v-text-field>
                <v-btn @click="clear()"><v-icon>mdi-close</v-icon></v-btn>
              </div>
            </div>
            <div class="custom-icon-wrapper" v-if="enableAddTopParnetStructure">
              <v-icon @click="addParentStructure(null);">custom-icon plus-icon</v-icon>
            </div>
          </div>
          <v-treeview class="flex-1 overflow-auto" dense :active:sync="active" :items="items" ref="tree"
            :load-children="fetchStructure" :open="openNodes" activatable item-key="id" color="success" open-on-click
            transition>
            <template v-slot:label="{ item }">
              <div @contextmenu="show($event, item)" :style="{ color: item.active ? 'inherit' : 'red' }">
                {{ (language == 'ar' && item.nameAr != '') ? item.nameAr : item.name }}
              </div>
            </template>
            <template v-slot:prepend="{ item, open }">
              <div @contextmenu="show($event, item)" :style="{ color: item.active ? 'inherit' : 'red' }">
                <v-icon v-if="item.children">
                  {{ open ? 'mdi-folder-open' : 'mdi-folder-multiple-outline' }}
                </v-icon>
                <v-icon v-else>mdi-account</v-icon>
                <span> {{ item.text }}</span>
              </div>
            </template>
          </v-treeview>
          <!--</div>-->
        </div>
        <div class="form-section col-md-8 col-lg-8 p-0 overflow-auto" style="height: calc(85vh); max-height: calc(85vh)"
          v-if="showSignSendPane || showTemplateDelegation || add_edit_Structure || showAutoForwardPane
                        || showUsername || showManageUsers|| footer || showManageTemplates || showStructureStampPane || showManageStructureStampPane||showFillingPlan||showClassificationPlan"> 
          <div v-if="showSignSendPane" class="h-100 w-100">
            <SendSignRule :key="sendSignRuleKey" :structure_id="sendStructureIdProp"></SendSignRule>
          </div>

          <div v-if="showAutoForwardPane" class="h-100 w-100">
            <AutoForward :key="templatKey" :structureId="sendStructureIdProp"></AutoForward>
          </div>

          <div v-if="showTemplateDelegation" class="h-100 w-100">
            <TemplateDelegate :key="templateDelagationKey" :structure_id="sendStructureIdProp">
            </TemplateDelegate>
          </div>

          <div v-if="showManageTemplates" class="h-100 w-100">
            <ManageTemplate :key="templatKey" :structure_id="sendStructureIdProp">
            </ManageTemplate>
          </div>

          <div v-if="showStructureStampPane" class="h-100 w-100">
            <StructureStamp :key="showStructureStampKey" :structure_id="sendStructureIdProp">
            </StructureStamp>
          </div>

          <div v-if="showManageStructureStampPane" class="h-100 w-100">
            <ManageStructureStamp v-if="constants.allowMultiStamp" :key="showStructureStampKey" :structure_id="sendStructureIdProp">
            </ManageStructureStamp>
          </div>

          <div :key="fillingPlanKey" v-if="showFillingPlan" class="h-100 w-100">
              <ManageFilingClassificationPlan :structureId="sendStructureIdProp" :mode="filingClassificationPlanMode"></ManageFilingClassificationPlan>
          </div>

          <div :key="classificationKey" v-if="showClassificationPlan" class="h-100 w-100">
              <ManageFilingClassificationPlan :structureId="sendStructureIdProp" :mode="filingClassificationPlanMode"></ManageFilingClassificationPlan>
          </div>

          <div :key="manageUsersKey" v-if="showManageUsers" class="h-100 w-100">
            <ManageUsers   :structureId1="sendStructureIdProp" :structureProps="structureProp" :fromOrganaize="true">
            </ManageUsers>
          </div>

          <!-- Add Edit -->
          <!--<v-container fluid class="m-0 p-0 h-100">-->
          <v-card class="h-100" v-if="add_edit_Structure" ref="AddEditStructure">
            <v-toolbar class="shadow-none" content-class="h-auto">
              <div class="d-flex align-items-center">
                <v-toolbar-title class="size-16 dark-text">
                  {{ this.currentStructureName }} {{ this.currentStructureMode }}
                </v-toolbar-title>
              </div>
              <v-spacer></v-spacer>
            </v-toolbar>

            <div class="border-top p-4 flex-1 overflow-auto">
              <v-layout wrap>
                <div class="flex-1">
                  <label>{{ $t("res_Label_Code") }}</label>
                  <v-text-field v-model="structureForm.code" label="" solo></v-text-field>
                </div>
                <div class="flex-1">
                  <label class="">{{ $t("res_Label_Name") }}<span> *</span></label>
                  <v-text-field v-model="structureForm.name" :rules="rules" label="" solo></v-text-field>
                </div>
              </v-layout>

              <v-layout wrap>
                <div class="flex-1">
                    <label>{{ $t("res_Label_NameAr") }}</label>
                    <v-text-field v-model="structureForm.nameAr" @keydown="checkArabicEvent($event)" label="" solo></v-text-field>
                </div>
                <div class="flex-1" v-if="this.defaultApplicationId == 1">
                    <label>{{ $t('res_Label_DisableTransfer') }}</label>
                    <v-checkbox v-model="structureForm.disableTransfers" label="" solo></v-checkbox>
                </div>
                <div class="flex-1">
                  <label>{{ $t('res_Label_IsExternal') }}</label>
                  <v-checkbox v-model="structureForm.external" label="" solo></v-checkbox>
                </div>
              </v-layout>

              <v-layout wrap v-if="constants.isFullAdmin && enableEntityConfiguration">
                <div class="flex-1">
                  <label>{{ $t('res_Label_IsCompany') }}</label>
                  <v-checkbox v-model="structureForm.isCompany" :disabled="isEdit" label="" solo></v-checkbox>
                </div>
              </v-layout>

              <v-layout wrap>
                <div class="flex-1" v-if="structureForm.isCompany && constants.isFullAdmin && enableEntityConfiguration">
                  <label>{{ $t('res_Label_StorageDatabaseName') }}</label>
                  <v-text-field v-model="structureForm.storageDatabaseName" label="" solo></v-text-field>
                </div>
                <div class="flex-1" v-if="structureForm.isCompany && constants.isFullAdmin && enableEntityConfiguration">
                  <label>{{ $t('res_Label_StorageFile') }}</label>
                  <v-text-field v-model="structureForm.storageFile" label="" solo></v-text-field>
                </div>
              </v-layout>

              <v-layout wrap style="display: none">
                <div class="flex-1">
                  <label class="ml-3">{{ $t("res_Label_Manager") }}</label>
                  <Multiselect style="width: 400px" v-model="structureForm.manager" label="name" track-by="id"
                    open-direction="bottom" placeholder="Select manager" :options="exceptionUsers" :searchable="true"
                    :loading="loading" :internal-search="false" dense :clear-on-select="true" :close-on-select="true"
                    :options-limit="300" :max-height="600" :show-no-results="false" :hide-selected="false"
                    :multiple="false" outlined @search-change="asyncFindExceptionUser" @close="exceptionUsers = []">
                    <template slot="option" slot-scope="props">
                      <div style="height: 50px; width: 100%; display: flex">
                        <div class="" style="">
                          <v-avatar color="#eff2f5" size="43">{{ CapitalizeFirstLetter(props.option.name) }}</v-avatar>
                        </div>
                        <div class="ad__box" v-if="props.option.isUser">
                          <p class="ad__text__bold">{{ props.option.name }}</p>
                          <p class="ad__text">
                            {{ GetMultiSelectSubHeaderDisplay(props.option) }}
                          </p>
                        </div>
                        <div class="ad__box" v-else>
                          <p class="ad__text__bold">{{ props.option.name }}</p>
                          <p class="ad__text">
                            {{ GetMultiSelectSubHeaderDisplay(props.option) }}
                          </p>
                        </div>
                      </div>
                    </template>
                    <template slot="noOptions" slot-scope="props">
                      {{ $t("res_Msgs_EmptySearch") }}
                    </template>
                  </Multiselect>
                </div>
              </v-layout>

              <div class="actions d-flex">
                <v-btn @click="submitData" color="primary" dense>
                  {{ $t("res_ButtonText_Submit") }}
                </v-btn>
              </div>
            </div>
          </v-card>
        </div>
            <v-menu v-model="showMenu" :position-x="x" :position-y="y" class="menu" :offset-y="offset"
                :close-on-content-click="false">
                <v-list>
                    <v-list-item v-for="(item, i) in menuItems" :key="i" @click="openOptionPane(item.id)">
                        <v-icon color="navy" v-text="item.icon"></v-icon>&nbsp;{{ item.title }}
                    </v-list-item>
                </v-list>
            </v-menu>
        </div>
    </v-card>
    <div v-if="showAddDynamicFormComponent" class=" w-100">
        <DynamicFomrBuilder :structure_id="sendStructureIdProp">
        </DynamicFomrBuilder>
    </div>
</div>
</template>
    
<script>
import axios from 'axios'
import router from '@/router/index.js'
import constants from '@/assets/js/constants'
import Multiselect from 'vue-multiselect'
import SendSignRule from '@/components/SendSignRule.vue'
import AutoForward from '@/components/AutoForward.vue'
import TemplateDelegate from '@/components/TemplateDelegate.vue'
import ManageTemplate from '@/components/ManageTemplate.vue'
import StructureStamp from '@/components/StructureStamp.vue'
import ManageStructureStamp from '@/components/ManageStructureStamp.vue'
import ManageFilingClassificationPlan from '@/components/ManageFilingClassificationPlan.vue'
import DynamicFomrBuilder from '@/components/DynamicFomrBuilder.vue'
import ManageUsers from './ManageUsers.vue'

import * as utils from '@/assets/js/common.js'

export default {
    name: 'OrgManagement',
    components: { SendSignRule, AutoForward, TemplateDelegate, Multiselect, ManageTemplate, StructureStamp, ManageStructureStamp, ManageFilingClassificationPlan, DynamicFomrBuilder,ManageUsers },
    data() {
        return {
            showUpdateStructureUserBtn: false,
            language:'en',
            show1: false,
            offset: true,
            password: 'Password',
            active: [],
            currentUserId: 1,
            selectedStructureId: 1,
            selectedParentId: 0,
            currentStructureName: '',
            currentStructureMode: '',
            userId: '',
            exceptionUsers: [],
            managers: [],
            selectedUsers: [],
            selectedStructureUserIds: [],
            uploadedFile: [],
            structureForm: {
                code: '',
                name: '',
                manager: [],
                nameFr: '',
                nameAr: '',
                external: false,
                active: true,
                disableTransfers: false,
                document_date_menu: false,
                date: '',
                isCompany: false,
                storageDatabaseName: '',
                storageFile: ''
            },
            structureData: {
                structureDataArray: []
            },
            image: null,
            showMenu: false,
            isEdit: false,
            loading: false,
            showUsers: false,
            showManageTemplates: false,
            showManageUsers: false ,
            showUsername: false,
            searchVal: '',
            rules: [
                    value => !!value || 'This value is required.',
                    value => (value && value.length >= 1),
            ],
            structureHeaders: [
                { text: 'Id', value: 'id', sortable: false, align: ' d-none'},
                { text: 'Structure Name', value: 'structure', sortable: false },
                { text: 'Privacy Level', value: 'privacyLevel', sortable: false },
                { text: 'Contact Role', value: 'contactRole', sortable: false },
                { text: 'Profession', value: 'profession', sortable: false },
                { text: 'Profession Ar', value: 'ProfessionAr', sortable: false },
                { text: 'Structure Receiver', value: 'isStructureReceiver', sortable: false },
                { text: 'Designated Person', value: 'isDesignatedPerson', sortable: false },
            ],
            systemRoles: [
                { text: 'Administrator', value: 1 },
                { text: 'User', value: 2 }
            ],
            genders: [
                { text: 'Male', value: 'M' },
                { text: 'Female', value: 'F' }
            ],
            privacy_items: [],
            contactRoles: [],
         
            items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
            x: 0,
            y: 0,
            menuItems: [
                {
                    id: 1,
                    title: this.$t("res_MenuItem_SignAndSend"),
                    icon: 'mdi-send',
                    showForApplications: [1],
                    isShown : true
                },
                {
                    id: 2,
                    title: this.$t("res_MenuItem_AutoForward"),
                    icon: 'mdi-security',
                    showForApplications: [1],
                    isShown : window.showAutoforward
                },

                {
                    id: 3,
                    title: this.$t("res_MenuItem_DelegationTemplate"),
                    icon: 'mdi-account-switch',
                    showForApplications: [1],
                    isShown : true
                },
                {
                    id: 4,
                    title: this.$t("res_MenuItem_Add"),
                    icon: 'mdi-plus-box',
                    showForApplications: [1,2,3],
                    isShown : true
                },
                {
                    id: 5,
                    title: this.$t("res_MenuItem_Edit"),
                    icon: 'mdi-pencil-box-outline',
                    showForApplications: [1,2,3],
                    isShown : true
                },
                {
                    id: 6,
                    title: this.$t("res_MenuItem_Delete"),
                    icon: 'mdi-minus-circle',
                    showForApplications: [1,2,3],
                    isShown : true
                },
                {
                    id: 7,
                    title: this.$t("res_MenuItem_ManageTemplate"),
                    icon: 'mdi-file-document',
                    showForApplications: [1],
                    isShown : true
                },
                {
                    id: 8,    
                    title: this.$t("res_MenuItem_ActiveStructure"),
                    icon:   'mdi-play-circle',
                    showForApplications: [1,2,3],
                    isShown : true
                },
                {
                    id: 9,    
                    title: this.$t("res_MenuItem_AddStructureStamp"),
                    icon:   'mdi-file-image',
                    showForApplications: [1],
                    isShown : true
                },
                {
                    id: 10,   
                    title: this.$t("res_MenuItem_ManageFilingPlan"), 
                    icon: 'mdi-application',
                    showForApplications: [1],
                    isShown : true
                }, 
                {
                    id: 11,   
                    title: this.$t("res_MenuItem_ManageClassification"), 
                    icon: 'mdi-book',
                    showForApplications: [1] ,
                    isShown : true
                },
                {
                    id: 13,    
                    title: this.$t("res_MenuItem_ManageViwerStamp"),
                    icon:   'mdi-file-image',
                    showForApplications: [1],
                    isShown : constants.allowMultiStamp
                }, 
                {
                    id: 14,   
                    title: this.$t("res_Title_ManageUsers"), 
                    icon: 'mdi-account',
                    showForApplications: [1], 
                    isShown : true
                }, 
            ],
            items: [],
            openNodes: [],
            clickedUser: true,
            clickedWindow: false,
            showList: false,
            showSignSendPane: false,
            showAutoForwardPane: false,
            showTemplateDelegation: false,
            showStructureStampPane: false,
            showManageStructureStampPane: false,
            showStructureStampKey: 0,
            showManageStructureStampKey: 0,
            delegateKey: 0,
            add_edit_Structure: false,
            editStructureDialog: false,
            addUser: false,
            userMetadata: false,
            disableFields: false,
            disableMailField: false,
            showStructures: false,
            showApplications: false,
            isSubmit: true,
            footer: false,
            sendStructureIdProp: 0,
            autoForwardKey: 0,
            templateDelagationKey: 0,
            sendSignRuleKey: 0,
            templatKey: 0,
            fillingPlanKey:0,
            classificationKey:0,
            constants: constants,
            enableEntityConfiguration: admin_enableEntityConfiguration,
            enableAddTopParnetStructure: true,
            showFillingPlan:false,
            showClassificationPlan:false,
            filingClassificationPlanMode: null,
            showAddDynamicFormComponent: false,
            defaultApplicationId: 1,
            manageUsersKey:0,
            structureProp: {}
        };
    },
    watch: {
        uploadedFile(newSource, oldSource) {
            if (newSource != oldSource) {
                var binaryData = [];
                binaryData.push(newSource);
                this.image = URL.createObjectURL(new Blob(binaryData, { type: "image/png" }))
            }
        }
    },
    mounted() 
    {
        this.defaultApplicationId = constants.defaultApplicationId;
        this.asyncFindExceptionUser("");
        this.asyncStructuresTreeView();
        this.getConstantData();
        this.language = localStorage.getItem('lang');
        eval(admin_enableEntityConfiguration);
      
        if (!admin_enableAddTopParentForNonAdmin && !constants.isFullAdmin) 
        {
            this.enableAddTopParnetStructure = false;
        }

        // Hide add top parent structure button for power user role
        if (constants.roleName && constants.roleName.toLowerCase() === 'power users') 
        {
            this.enableAddTopParnetStructure = false;
        }

        if (constants.client_version_Id != 'DGS') 
        {
            this.menuItems.push({
                id: 12,
                title: this.$t("res_MenuItem_AddDynamicForms"),
                icon: 'mdi-contrast-box',
                showForApplications: [1],
                isShown: true
            });
        }

        // show only menu items per application
        var menuItemsToShow = []
        this.menuItems.forEach(item => {
            if (item.showForApplications.includes(defaultApplicationId))
                menuItemsToShow.push(item);
        });
        
        this.menuItems = menuItemsToShow;
        this.menuItems = this.menuItems.filter(item => item.isShown);
    },
    methods:
    {
        checkArabicEvent(e)
        {
            const arabicRegex = /^[\u0600-\u06FF\s]+$/;
            if (e.key !== 'Backspace' && e.key !== 'Delete' && !arabicRegex.test(e.key)) 
            {
                e.preventDefault();
                window.showAlert(this.$t('res_Msgs_NotValidArabicName'),'warning');
            }
        },
        async readFile(file, successHandler) {
            var reader = new FileReader();
                var fileByteArray = [];
                reader.readAsArrayBuffer(file);
                reader.onloadend = function (evt) {
                    if (evt.target.readyState == FileReader.DONE) {
                        var arrayBuffer = evt.target.result,
                            array = new Uint8Array(arrayBuffer);
                        for (var i = 0; i < array.length; i++) {
                            fileByteArray.push(array[i]);
                        }
                        
                        successHandler(fileByteArray);
                    }
                }
        },
        getConstantData() {
            this.privacy_items = constants.privacies;
            this.contactRoles = constants.contactRoles;
        },
        backToAdminPage() {
            router.push({ name: 'admin' })
        },
        showEditStructureUserData(item) {
            this.showUpdateStructureUserBtn = true;
            this.structureData.structure = { name: item.structure, id: item.id };
            this.structureData.structureDisable = true;
            this.structureData.contactRole = this.contactRoles.find(x => x.name == item.contactRole);
            this.structureData.privacyLevel = this.privacy_items.find(x => x.name == item.privacyLevel);
            this.structureData.profession = item.profession;
            this.structureData.professionAr = item.ProfessionAr;
            this.structureData.isStructureReceiver = item.isStructureReceiver;
            this.structureData.isDesignatedPerson = item.isDesignatedPerson;
        },
        handleSearch: function () {
            if (this.searchVal != "") {
                window.showLoading()
                var params = "?search=" + this.searchVal;
                axios.get(constants.baseApiUrl + 'Admin/GetAllStructuresForOrganizationManagement' + params, { headers: constants.headers })
                    .then(res => 
                    {
                        if (res.data != null)
                        {
                            this.openNodes = []
                            this.items = res.data;
                             this.items.forEach(ele => {
                               this.insertion(ele);
                            });

              if (this.items.length > 0) {
                this.$refs.tree.updateAll(true);
              }
            }
          })
          .catch(err => console.warn(err))
          .finally(() => window.hideLoading());
      }
      else {
        this.asyncStructuresTreeView();
      }
    },
    clear() {
      this.searchVal = '';
      this.items = [];
      this.openNodes = [];
      this.asyncStructuresTreeView();
    },
    insertion: function (ele) {
      ele.isUser = ele.userId != null
      ele.isChild = true
      ele.position = ele.position

      this.openNodes.push(ele.id)
      if (ele.children.length > 0) {
        ele.children.forEach(item => {
          this.insertion(item)
        });
      }
    },
    async asyncStructuresTreeView() {
      this.items = [];
      axios.get(constants.baseApiUrl + 'Admin/GetAllStructuresForOrganizationManagement')
        .then((res) => {
          if (res.data != null) {
            res.data.forEach(element => {
              var item = {
                id: element.id,
                name: element.name,
                nameAr: element.nameAr,
                children: [],
                active: element.active,
                external: element.isExternal
              };
              this.items.push(item);
            });
          }
        }).catch(err => console.warn(err))
    }, 
    asyncFindExceptionUser(query) {
      var methodUrl = 'StructureUser/search?showUsers=true&showInternalStructures=false&showExternalStructures=false&disableOtherInternalEntitiesAsExternal=true&search=';

      axios.get(constants.baseApiUrl + methodUrl + query, { headers: constants.headers })
        .then(res => {
          if (res.data != null) {
            this.exceptionUsers = res.data
          }
        })
        .catch(err => console.warn(err))
    },
    async fetchStructure(item) {
  return axios.get(constants.baseApiUrl + 'Admin/GetAllStructuresForOrganizationManagement?parentId=' + item.id, { headers: constants.headers })
    .then(res => {
      if (res.data != null) {
        var jsonObjects = [];
        res.data.forEach(element => {
          var childItem = {
            id: element.id,
            name: element.name,
            nameAr: element.nameAr,
            children: [],
            active: element.active,
            external: element.isExternal
          };
          jsonObjects.push(childItem);
        });
      }  
      item.children.push(...jsonObjects);
    })
    .catch(err => console.warn(err))
    },
    getSelectedStructureData(id) {
      return axios.get(constants.baseApiUrl + 'StructureUser/GetSelectedStructure?ids=' + id.toString(), { headers: constants.headers })
        .then(res => {
          if (res.data != null) {
            this.structureForm.code = res.data[0].code
            this.structureForm.name = res.data[0].name
            this.structureForm.nameAr = res.data[0].nameAr
            this.structureForm.external = res.data[0].external
            this.structureForm.isCompany = res.data[0].isCompany
            this.structureForm.storageDatabaseName = res.data[0].storageDatabaseName
            this.structureForm.storageFile = res.data[0].storageFile
            this.structureForm.disableTransfers = res.data[0].disableTransfers
            this.structureForm.active = res.data[0].active

            this.selectedParentId = res.data[0].structureParentId
            this.structureForm.manager = { id: res.data[0].managerId, name: res.data[0].managerName }
          }
        })
        .catch(err => console.warn(err))
    },
    clearUserDropdown() {
      this.getStructureUserIds(this.selectedStructureId);
    },
    searchSelectedStructureUser() {
      var selectedStructureUserIds = [];
      if (this.structureForm.manager != null) {
        this.selectedStructureUserIds.forEach(element => {
          if (element == this.structureForm.manager.id)
            selectedStructureUserIds.push(element)
        })
      }
      else
        this.getStructureUserIds(this.selectedStructureId)

      this.getSelectedUsers(selectedStructureUserIds);
    },
    getStructureUserIds(id) {
      this.selectedStructureUserIds = [];

      return axios.get(constants.baseApiUrl + 'StructureUser/GetSelectedStructureUserIds?id=' + id, { headers: constants.headers })

        .then(res => {
          if (res.data != null) {
            res.data.forEach(element => {
              this.selectedStructureUserIds.push(element.userId);
            })
            this.getSelectedUsers(this.selectedStructureUserIds);
          }
        }).catch(err => console.warn(err))
    },
    show(e, item) {
      e.preventDefault()
      this.selectedStructureId = item.id
      this.showMenu = false
      this.currentStructureName = item.name
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showMenu = true
      })
    },
    resetFiles() {
      this.structureForm.code = ''
      this.structureForm.name = ''
      this.structureForm.nameAr = ''
      this.structureForm.nameFr = ''
      this.structureForm.manager = []
      this.structureForm.external = false
      this.structureForm.isCompany = false
      this.structureForm.storageDatabaseName = ''
      this.structureForm.storageFile = ''
      this.structureForm.disableTransfers = false
    },
    submitData() {
      if (this.isEdit) {
        if (this.structureForm.name) {
          var updateStructure = {
            id: this.selectedStructureId,
            Code: this.structureForm.code,
            Name: this.structureForm.name,
            NameAr: this.structureForm.nameAr,
            StructureParentId: this.selectedParentId,
            ModifiedDate: Date.now,
            External: this.structureForm.external,
            IsCompany: this.structureForm.isCompany,
            StorageDatabaseName: this.structureForm.storageDatabaseName,
            StorageFile: this.structureForm.storageFile,
            DisableTransfers: this.structureForm.disableTransfers,
            Active: this.structureForm.active,
          }

          window.showLoading();
          axios.post(constants.baseApiUrl + 'StructureUser/UpdateStructureForTreeView', updateStructure, { headers: constants.headers })
            .then(res => {
              if (res.data != null) {
                window.showAlert('res_Msgs_StructureUpdated', 'success')
                this.clearAddEditStructureFields()
                this.asyncStructuresTreeView()
              }
            }).catch(err => console.warn(err))
            .finally(() => { window.hideLoading(); })
        }
        else
          window.showAlert('res_Msgs_FillRequired', 'warning')
      }
            else 
            {
                if (this.structureForm.name) 
                {
                    var addNewStructureBody = {
                        Code: this.structureForm.code,
                        Name: this.structureForm.name,
                        NameAr: this.structureForm.nameAr,
                        StructureParentId: this.selectedStructureId,
                        CreatedDate: Date.now,
                        External: this.structureForm.external,
                        IsCompany: this.structureForm.isCompany,
                        StorageDatabaseName: this.structureForm.storageDatabaseName,
                        StorageFile: this.structureForm.storageFile,
                        DisableTransfers: this.structureForm.disableTransfers,
                        Active: this.structureForm.active
                    }

                    window.showLoading();
                    axios.post(constants.baseApiUrl + 'StructureUser/AddStructureForTreeView', addNewStructureBody, { headers: constants.headers })
                        .then(res => 
                        {
                            if (res.data != null)
                            {
                                window.showAlert('res_Msgs_StructureAdded', 'success')
                                this.clearAddEditStructureFields()
                                this.asyncStructuresTreeView()
                            }
                        }).catch(err => console.warn(err))
                        .finally(()=>{window.hideLoading();})
                }
                else
                    window.showAlert('res_Msgs_FillRequired', 'warning')
            }
        },
        clearAddEditStructureFields()
        {
            this.add_edit_Structure = false
            this.structureForm.code = ''
            this.structureForm.name = ''
            this.structureForm.nameAr = ''
            this.structureForm.external = false
            this.selectedParentId = null,
                this.structureForm.isCompany = false,
                this.structureForm.storageDatabaseName = '',
                this.structureForm.storageFile = ''
            this.structureForm.disableTransfers = false
        },
        CapitalizeFirstLetter(str) {
            return utils.CapitalizeFirstLetter(str)
        },
        GetMultiSelectSubHeaderDisplay(options) {
            return utils.GetMultiSelectSubHeaderDisplay(options)
        },
        addParentStructure(parentId) {
            this.selectedStructureId = parentId;
            this.currentStructureMode = '';
            this.openOptionPane(4);
        },
        openOptionPane(id) { 
            if (id == 1) 
            {
                this.showTemplateDelegation = false;
                this.add_edit_Structure = false;
                this.isEdit = false;
                this.showUsername = false;
                this.footer = false;
                this.showManageTemplates = false;
                this.showStructureStampPane = false
                this.showManageUsers = false;
                this.showManageStructureStampPane = false
                this.sendStructureIdProp = this.selectedStructureId
                this.showSignSendPane = true;
                this.showAutoForwardPane = false;
                this.showFillingPlan = false;
                this.showClassificationPlan = false;
                this.sendSignRuleKey += this.sendSignRuleKey + 1;
            }
            else if (id == 2) {
                this.showAutoForwardPane = true;
                this.showTemplateDelegation = false;
                this.showSignSendPane = false;
                this.add_edit_Structure = false;
                this.isEdit = false;
                this.showUsername = false;
                this.showManageUsers = false;
                this.footer = false;
                this.showManageTemplates = false;
                this.showStructureStampPane = false
                this.showManageStructureStampPane = false
                this.sendStructureIdProp = this.selectedStructureId
                this.showFillingPlan = false;
                this.showClassificationPlan = false;
                this.autoForwardKey += this.autoForwardKey + 1;
            }
            else if (id == 3) {
                this.showSignSendPane = false;
                this.add_edit_Structure = false;
                this.showAutoForwardPane = false;
                this.isEdit = false;
                this.showUsername = false;
                this.footer = false;
                this.showManageTemplates = false;
                this.showManageUsers = false;
                this.showStructureStampPane=false
                this.showManageStructureStampPane = false
                this.sendStructureIdProp = this.selectedStructureId
                this.showTemplateDelegation = true;
                this.showFillingPlan=false;
                this.showClassificationPlan = false;
                this.templateDelagationKey += this.templateDelagationKey + 1;
            }
            else if (id == 4) 
            {
                this.showSignSendPane = false;
                this.showAutoForwardPane = false;
                this.showTemplateDelegation = false;
                this.isEdit = false;
                this.showUsername = false;
                this.footer = false;
                this.showManageTemplates = false;
                this.showManageUsers = false;
                this.showStructureStampPane=false;
                this.showManageStructureStampPane = false
                this.showFillingPlan=false;
                this.showClassificationPlan = false;
                this.resetFiles()
                this.currentStructureMode = ' / (' + this.$t('res_Label_NewStructure') +')'
                this.add_edit_Structure = true;
            }
            else if (id == 5) 
            {
                this.showSignSendPane = false;
                this.showAutoForwardPane = false;
                this.showTemplateDelegation = false;
                this.isEdit = true;
                this.showUsername = false;
                this.footer = false;
                this.showManageTemplates = false;
                this.showManageUsers = false;
                this.showStructureStampPane = false;
                this.showManageStructureStampPane = false
                this.showFillingPlan = false;
                this.showClassificationPlan = false;
                this.getSelectedStructureData(this.selectedStructureId);
                this.currentStructureMode = ' / (' + this.$t('res_Label_EditStructure') + ')'
                this.add_edit_Structure = true;
            }
            else if (id == 6) 
            {  
                window.showInformation(this.$t("res_Msg_DeleteConfirmation"), this.$t("res_Msgs_DeleteItemStructureDepartment"),
                    () => 
                    { 
                        window.showLoading();
                        axios.get(constants.baseApiUrl + 'StructureUser/DeleteStructureForTreeView?structureId=' + this.selectedStructureId, { headers: constants.headers })
                            .then(res => 
                            {
                                if (res.data != null && res.data == true)
                                {
                                    window.showAlert('res_Msgs_StructureDeleted', 'success')
                                    this.asyncStructuresTreeView()
                                }
                                else
                                {
                                    window.showAlert('res_Msgs_StructureDeleteViolation', 'warning')
                                }
                            })
                            .catch(err => console.warn(err))
                            .finally(()=>{window.hideLoading();})
                    },
                    () => 
                    { })
            }
            else if (id == 7) 
            {
                this.showSignSendPane = false
                this.showAutoForwardPane = false;
                this.showTemplateDelegation = false
                this.isEdit = false
                this.add_edit_Structure = false
                this.footer = false
                this.disableFields = false
                this.disableMailField = false
                this.showManageUsers = false;
                this.image = null
                this.showUsername = false
                this.showStructureStampPane = false
                this.showManageStructureStampPane = false
                this.showManageTemplates = true
                this.sendStructureIdProp = this.selectedStructureId;
                this.showFillingPlan = false;
                this.showClassificationPlan = false;
                this.showStructureStampKey += this.showStructureStampKey + 1
            }
            else if (id == 8)
            {
              window.showLoading();
              axios.get(constants.baseApiUrl + 'StructureUser/ToggleActiveStructure?structureId=' + this.selectedStructureId, { headers: constants.headers })
                  .then(res => 
                  {
                      if (res.data != null && res.data == "Active")
                      {
                          window.showAlert('res_Msgs_StructureActive', 'success')
                          this.asyncStructuresTreeView() 
                      }
                      else if(res.data != null && res.data == "Deactive")
                      {
                        window.showAlert('res_Msgs_StructureDeActive', 'success')
                          this.asyncStructuresTreeView()
                      }
                      else 
                      {
                          window.showAlert('res_Msgs_StructureActiveDeactiveViolation', 'warning')
                      }
                  })
                  .catch(err => console.warn(err))
                  .finally(()=>{window.hideLoading();})
            }
            else if(id==9){
                this.showTemplateDelegation = false;
                this.showAutoForwardPane = false;
                this.add_edit_Structure = false;
                this.isEdit = false;
                this.showUsername = false;
                this.footer = false;
                this.showManageTemplates = false;
                this.sendStructureIdProp = this.selectedStructureId
                this.showManageUsers = false;
                this.showSignSendPane = false;
                this.showStructureStampPane=true;
                this.showManageStructureStampPane = false
                this.showFillingPlan = false;
                this.showClassificationPlan = false;
                this.sendSignRuleKey += this.sendSignRuleKey + 1;
            }
            else if(id==10){
                this.showTemplateDelegation = false;
                this.showAutoForwardPane = false;
                this.add_edit_Structure = false;
                this.isEdit = false;
                this.showUsername = false;
                this.footer = false;
                this.showManageTemplates = false;
                this.showManageUsers = false;
                this.sendStructureIdProp = this.selectedStructureId
                this.showSignSendPane = false;
                this.showStructureStampPane=false;
                this.showManageStructureStampPane = false
                this.sendSignRuleKey += this.sendSignRuleKey + 1;
                this.showFillingPlan = true;
                this.showClassificationPlan = false;
                this.filingClassificationPlanMode = 1;
                this.fillingPlanKey += this.fillingPlanKey + 1;
            }
            else if(id==11){
                this.showTemplateDelegation = false;
                this.showAutoForwardPane = false;
                this.add_edit_Structure = false;
                this.isEdit = false;
                this.showUsername = false;
                this.footer = false;
                this.showManageTemplates = false;
                this.showManageUsers = false;
                this.sendStructureIdProp = this.selectedStructureId
                this.showSignSendPane = false;
                this.showStructureStampPane=false;
                this.showManageStructureStampPane = false
                this.sendSignRuleKey += this.sendSignRuleKey + 1;
                this.showFillingPlan = false;
                this.showClassificationPlan = true;
                this.filingClassificationPlanMode = 2;
                this.classificationKey += this.classificationKey + 1;
            }
            else if (id == 12) {
                this.sendStructureIdProp = this.selectedStructureId;
                this.showAutoForwardPane = false;
                if (this.showAddDynamicFormComponent)
                    this.showAddDynamicFormComponent = false;
                setTimeout(() => {
                    this.showAddDynamicFormComponent = true;

                }, 200);
            }
            else if(id==13){
                this.showTemplateDelegation = false;
                this.showAutoForwardPane = false;
                this.add_edit_Structure = false;
                this.isEdit = false;
                this.showUsername = false;
                this.footer = false;
                this.showManageTemplates = false;
                this.showManageUsers = false;
                this.sendStructureIdProp = this.selectedStructureId
                this.showSignSendPane = false;
                this.showStructureStampPane=false;
                this.showManageStructureStampPane = true
                this.showFillingPlan = false;
                this.showClassificationPlan = false;
                this.sendSignRuleKey += this.sendSignRuleKey + 1;
            }
            else if (id == 14) 
          { 
                this.showSignSendPane = false;
                this.add_edit_Structure = false;
                this.isEdit = false;
                this.showUsername = false;
                this.sendStructureIdProp = this.selectedStructureId
                this.footer = false;
                this.showManageTemplates = false;
                this.showStructureStampPane=false
                this.showManageUsers = true;
                this.showTemplateDelegation = false;
                this.showFillingPlan=false;
                this.showClassificationPlan = false;
                this.showManageStructureStampPane = false
                this.manageUsersKey += this.manageUsersKey + 1;
                // this.structureProp = this.items.find(x=>x.id == this.selectedStructureId) 
                let structure = this.searchStructureRecursively(this.items,this.selectedStructureId,{},0);
                this.structureProp = structure; 

          }
        },
        searchStructureRecursively(items,selectedStructureId,structure,index){ 
        if(index==items.length && (structure.id==null || structure.id == undefined)){
          return {};
        }
        else if(selectedStructureId==items[index].id) return items[index];
        else if(items[index].children!=null && items[index].children!=undefined && items[index].children.length>0){
          structure =this.searchStructureRecursively(items[index].children,selectedStructureId,{},0);
          if(structure.id!=undefined&&structure.id!=null) return structure;
          index = index + 1
          return this.searchStructureRecursively(items,selectedStructureId,structure,index);
        }
        else{
        index = index + 1
          return this.searchStructureRecursively(items,selectedStructureId,structure,index);
        }
      }
    }
}
</script>

<style scoped>
.hideDeleteButton {
  display: none
}

.v-list-item:hover,
.v-list-item[aria-expanded="true"] {
  background-color: #b8c0c8;
  color: #FFF !important;
}

.v-input--selection-controls {
  margin-top: 0px !important;
}
</style>